
























































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'
import axios, { CancelTokenSource } from 'axios'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import DialogoDeComandoDoItem from '@/components/integracao/DialogoDeComandoDoItem.vue'
import DialogoDeConfirmacaoDeReenvio from '@/components/integracao/DialogoDeConfirmacaoDeReenvio.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { buscarComando, buscarEstadoDasIntegracoes, listarItens, reenviar } from '@/api/painelDeIntegracao'
import {
	EstadoDasIntegracoes,
	ItemDoPainelDeIntegracao,
	ItemRecusadoNoReenvio,
	OperacaoDoItemDeIntegracao,
	SituacaoDoItemDeIntegracao,
	TipoDoItemDeIntegracao,
	rotulosDeOperacao,
	rotulosDeSituacao,
	rotulosDeTipo,
	situacoesQuePermitemReenvio,
} from '@/models/ItemDoPainelDeIntegracao'
import { sortConverter } from '@/shareds/paginacao'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'

@Component({
	components: {
		RangeDatePicker,
		DialogoDeComandoDoItem,
		DialogoDeConfirmacaoDeReenvio,
	},
})
export default class TelaDePainelDeIntegracao extends Vue {
	itens: ItemDoPainelDeIntegracao[] = []
	selecionados: { id: string }[] = []
	totalDeRegistros = 0
	buscando = false
	cancelToken: CancelTokenSource | null = null
	estadoDasIntegracoes: EstadoDasIntegracoes = {}

	dialogoDeComando = false
	itemEmVisualizacao: ItemDoPainelDeIntegracao | null = null
	comandoEmVisualizacao = ''
	carregandoComando: Record<string, boolean> = {}

	dialogoDeConfirmacao = false
	itensParaReenvio: ItemDoPainelDeIntegracao[] = []
	reenviando = false

	tipos = [
		{ text: rotulosDeTipo.PRODUTO, value: 'PRODUTO' },
		{ text: rotulosDeTipo.PRECO, value: 'PRECO' },
	]
	operacoes = [
		{ text: rotulosDeOperacao.CADASTRO, value: 'CADASTRO' },
		{ text: rotulosDeOperacao.ATUALIZACAO, value: 'ATUALIZACAO' },
		{ text: rotulosDeOperacao.REGRA_FISCAL, value: 'REGRA_FISCAL' },
		{ text: rotulosDeOperacao.IMAGENS, value: 'IMAGENS' },
	]
	situacoes = [
		{ text: rotulosDeSituacao.PENDENTE, value: 'PENDENTE' },
		{ text: rotulosDeSituacao.AGUARDANDO, value: 'AGUARDANDO' },
		{ text: rotulosDeSituacao.SUCESSO, value: 'SUCESSO' },
		{ text: rotulosDeSituacao.NOVO_ERRO, value: 'NOVO_ERRO' },
	]

	filtro = {
		tipo: [] as TipoDoItemDeIntegracao[],
		operacao: [] as OperacaoDoItemDeIntegracao[],
		situacao: [] as SituacaoDoItemDeIntegracao[],
		datas: [] as string[],
		busca: '',
	}

	headers = [
		{ text: 'Data e hora do erro', value: 'dataHoraDoErro' },
		{ text: 'Tipo', value: 'tipoRotulo', sortable: false },
		{ text: 'Operação', value: 'operacaoRotulo', sortable: false },
		{ text: 'Produto (SKU)', value: 'skuExibido', sortable: false },
		{ text: 'Ticket', value: 'ticket', sortable: false },
		{ text: 'Mensagem de erro', value: 'mensagemDeErro', sortable: false },
		{ text: 'Situação', value: 'situacao', sortable: false },
		{ text: 'Reenvios', value: 'reenvios', sortable: false },
		{ text: 'Ações', value: 'actions', sortable: false },
	]

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: ['dataHoraDoErro'],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	get itensFormatados() {
		return this.itens.map(item => ({
			...item,
			dataHoraDoErro: dateTimeToPtBrFormat(item.dataHoraDoErro),
			tipoRotulo: rotulosDeTipo[item.tipo],
			operacaoRotulo: rotulosDeOperacao[item.operacao],
			skuExibido: this.formatarSku(item),
			situacaoRotulo: rotulosDeSituacao[item.situacao],
			reenviavel: situacoesQuePermitemReenvio.includes(item.situacao),
		}))
	}

	get textoDeSelecionados() {
		const quantidade = this.selecionados.length
		return quantidade === 1 ? '1 item selecionado' : `${quantidade} itens selecionados`
	}

	get temItemDePrecoParaReenvio() {
		return this.itensParaReenvio.some(item => item.tipo === 'PRECO')
	}

	get integracaoPausada() {
		return this.itensParaReenvio.some(item => this.estadoDasIntegracoes[item.tipo]?.ativo === false)
	}

	get periodoDaBusca() {
		const [dataInicial, dataFinal] = [...this.filtro.datas].sort()
		return { dataInicial, dataFinal }
	}

	formatarSku(item: ItemDoPainelDeIntegracao) {
		if (!item.sku) return '-'
		const outros = item.quantidadeDeSkus - 1
		return outros > 0 ? `${item.sku} (+${outros})` : item.sku
	}

	corDaSituacao(situacao: SituacaoDoItemDeIntegracao) {
		if (situacao === 'SUCESSO') return 'success'
		if (situacao === 'NOVO_ERRO') return 'error'
		if (situacao === 'AGUARDANDO') return 'info'
		return 'warning'
	}

	pesquisar() {
		if (this.paginacao.page !== 1) {
			this.paginacao = { ...this.paginacao, page: 1 }
			return
		}
		this.buscar()
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		const cancelToken = axios.CancelToken.source()
		this.cancelToken = cancelToken
		this.buscando = true
		try {
			const sort = sortConverter(this.paginacao)
			const pagina = await listarItens({
				tipo: this.filtro.tipo,
				operacao: this.filtro.operacao,
				situacao: this.filtro.situacao,
				dataInicial: this.periodoDaBusca.dataInicial || undefined,
				dataFinal: this.periodoDaBusca.dataFinal || undefined,
				busca: this.filtro.busca?.trim() || undefined,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
				sort: sort.length ? sort : ['dataHoraDoErro,DESC'],
			}, { cancelToken: cancelToken.token })
			this.itens = pagina.content
			this.totalDeRegistros = pagina.totalElements
			this.selecionados = []
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			if (this.cancelToken === cancelToken) this.buscando = false
		}
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao() {
		this.buscar()
	}

	async verComando(item: ItemDoPainelDeIntegracao) {
		this.$set(this.carregandoComando, item.id, true)
		try {
			const { comando } = await buscarComando(item.id)
			this.itemEmVisualizacao = this.itens.find(original => original.id === item.id) || null
			this.comandoEmVisualizacao = comando
			this.dialogoDeComando = true
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.$set(this.carregandoComando, item.id, false)
		}
	}

	reenviarItem(item: ItemDoPainelDeIntegracao) {
		this.abrirConfirmacao(this.itens.filter(original => original.id === item.id))
	}

	reenviarSelecionados() {
		const idsSelecionados = this.selecionados.map(item => item.id)
		this.abrirConfirmacao(this.itens.filter(original => idsSelecionados.includes(original.id)))
	}

	async abrirConfirmacao(itens: ItemDoPainelDeIntegracao[]) {
		this.itensParaReenvio = itens
		await this.carregarEstadoDasIntegracoes()
		this.dialogoDeConfirmacao = true
	}

	async carregarEstadoDasIntegracoes() {
		try {
			this.estadoDasIntegracoes = await buscarEstadoDasIntegracoes()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async confirmarReenvio() {
		this.reenviando = true
		try {
			const { reenviados } = await reenviar(this.itensParaReenvio.map(item => item.id))
			this.dialogoDeConfirmacao = false
			AlertModule.setSuccess(
				reenviados.length === 1
					? '1 item reenviado. Acompanhe a situação neste painel.'
					: `${reenviados.length} itens reenviados. Acompanhe a situação neste painel.`,
			)
			await this.buscar()
		} catch (error: any) {
			if (error?.response?.status === 409 && error.response.data?.recusados) {
				this.dialogoDeConfirmacao = false
				AlertModule.setError(this.mensagemDeItensRecusados(error.response.data.recusados))
				await this.buscar()
				return
			}
			AlertModule.setError(error)
		} finally {
			this.reenviando = false
		}
	}

	mensagemDeItensRecusados(recusados: ItemRecusadoNoReenvio[]) {
		const itensPorSituacao = recusados.map(recusado => {
			const item = this.itens.find(original => original.id === recusado.itemId)
			const ticket = item ? `Ticket ${item.ticket}` : 'Item'
			return `${ticket}: ${rotulosDeSituacao[recusado.motivo]}`
		})
		return `Nenhum item foi reenviado, porque a situação mudou: ${itensPorSituacao.join('; ')}.`
	}
}
